'use strict';

var makeNonNullableArray = require('./makeNonNullableArray.js');

/**
 * Type guard - Checks if the provided value is a TypedElement, optionally of the specified type.
 *
 * @template T - The type of the TypedElement.
 * @param x - The value to check.
 * @param typename - Optional. The type name or an array of type names to match against.
 * @returns A boolean indicating whether the value is a TypedElement of the specified type.
 */ function isTypedElement(x, typename) {
    if (!x || typeof x !== 'object') return false;
    const isEl = !!x && '__typename' in x && typeof x.__typename === 'string';
    if (!isEl) return false;
    const el = x;
    const typenameArr = makeNonNullableArray(typename);
    return typename ? typenameArr.includes(el.__typename) : true;
}

module.exports = isTypedElement;
